export default {
  methods: {
    gotoFirstValidationError() {
      let ref = this.$refs[this.errors.items[0].field];

      if (ref.$el) {
        ref = ref.$el;
      }

      ref.scrollIntoView();
    }
  }
}
